import axios from '@/jslib/axios'

export const getIncentiveBonusList = (params) => {
  return axios({
    method: 'get',
    url: '/admin/special/referrer/top/list',
    params,
  })
}
export const getSpecialReferrerSummary = (params) => {
  return axios({
    method: 'get',
    url: '/admin/special/referrer/summary',
    params,
  })
}
export const getSpecialReferrerList = (data) => {
  return axios({
    method: 'post',
    url: '/admin/special/referrer/list',
    data,
  })
}
export const getSpecialReferrerDetail = (data) => {
  return axios({
    method: 'post',
    url: '/admin/special/referrer/detail',
    data,
  })
}
